export const SelectEventType = {
  Click: 'click',
  Close: 'close',
  Change: 'change',
};

export const SelectProperty = {
  Id: 'id',
  ClassName: 'className',
  Label: 'label',
  LabelColorScheme: 'labelColorScheme',
  Value: 'value',
  Disabled: 'disabled',
  IsReadonly: 'isReadonly',
  IsSearch: 'isSearch',
  ErrorMessage: 'errorMessage',
  Placeholder: 'placeholder',
  IsShowErrorMessage: 'isShowErrorMessage',
  Options: 'options',
  IsRequired: 'isRequired',
  IconColor: 'iconColor',
  ColorScheme: 'colorScheme',
  FillType: 'fillType',
};

export default {
  SelectEventType,
  SelectProperty,
};
